module.exports = __webpack_public_path__ + "facebook.svg?e5996e9ee08ec05fe7b1a321bc256c57";